import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import { getLogoImgURLFromUserKind } from "../../lib/func/ExportFunction";

const WebHeader = ({ userKind, isLoginYn, handleSelectedFunc }) => {

    const logoImgUrl = useMemo(() => getLogoImgURLFromUserKind(userKind), [userKind]);

    const onClickHomeImg = () => {
        if (isLoginYn === "N") {
            handleSelectedFunc({ selectedFunc: "REFRESH_HOME" });
        }
    }

    return (
        <Link to="/main" style={{ textDecoration: 'none' }}>
            <img
                style={{ width: 'auto', height: '100%', maxHeight: '75px' }}
                src={logoImgUrl}
                onClick={onClickHomeImg}
                alt={userKind + "_logo"}
            />
        </Link>
    );
}

export default WebHeader;